import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';

import { GenericdatasetSettings } from './genericdataset.settings';
import { Column } from './column';

@Injectable()
export class GenericdatasetService {
  public headers = new Headers({ 'Content-Type': 'application/json' });
  public options = new RequestOptions({ headers: this.headers });
  public itemsUrl: string;
  public restName: string;
  public modelName: string = 'Default';
  constructor(
    public http: Http) {
  }
  ngOnInit(): void {
  }
  getrestName(): string {
    return this.restName;
  }
  setrestName(restName: string) {
    this.restName = restName;
  }
  getmodelName(): string {
    return this.modelName;
  }
  setmodelName(modelName: string) {
    this.modelName = modelName;
  }
  getItemsCount(filter: any, requestOri?: any, globalFilter?: String): Observable<any> {
    const request = JSON.parse(JSON.stringify(requestOri));
    let url = '/count';
    let where: any = {};
    if (requestOri && requestOri.where) {
      where = JSON.parse(JSON.stringify(requestOri.where));
    } else {
      where = {
        and: [
          {
            active: true
          }
        ]
      };
    }
    if (filter != null && filter.length > 0) {
      for (let i = 0; i <= filter.length - 1; i++) {
        const fieldName: string = filter[i].fieldName;
        const filterO: any = {};
        filterO[fieldName] = filter[i].value;
        where['and'].push(filterO);
      }
    }
    if (globalFilter) {
      const globalWhere: any = {};
      globalWhere['or'] = [];
      const expression: any = {};
      expression['regexp'] = '/' + globalFilter + '/i';
      for (let i = 0; i <= request.columns.length - 1; i++) {
        if (request.columns[i].datatype == 0 && request.columns[i].visible) {
          const filterO: any = {};
          filterO[request.columns[i].fieldName] = expression;
          if (request.columns[i].includes) {
            if (request && request['relation'] && request['relation']['include']) {
              for (let j = 0; j <= request['relation']['include'].length - 1; j++) {
                if ((request.columns[i].includes) && (request['relation']['include'][j].relation == request.columns[i].includes[request.columns[i].includes.length - 1])) {
                  if (!request['relation']['include'][j].scope) {
                    request['relation']['include'][j]['scope'] = {};
                  }
                  if (!request['relation']['include'][j].scope.where) {
                    request['relation']['include'][j].scope['where'] = {};
                  }
                  if (!request['relation']['include'][j].scope.where.or) {
                    request['relation']['include'][j].scope.where['or'] = [];
                  }
                  request['relation']['include'][j].scope.where['or'].push(filterO);
                  break;
                }
              }
            }
          } else {
            globalWhere['or'].push(filterO);
          }
        }
      }
      if (globalWhere['or']) {
        where['and'].push(globalWhere);
      }
    }
    url = url + '?where=' + JSON.stringify(where);
    url = GenericdatasetSettings.api_endpoint + this.restName + url;
    return this.http.get(url, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getSymbol(url: string): string {
    if (url) {
      return '&';
    } else {
      return '?';
    }
  }

  getItems(page: number, perPage: number, filter: any, requestOri: any, globalFilter: String): Observable<any[]> {
    const request = JSON.parse(JSON.stringify(requestOri));
    let url = '';
    const skip = ((page - 1) * perPage);
    let filterO: string = '';
    let where: any = {};
    let order: string = '';
    if (requestOri && requestOri.where) {
      where = JSON.parse(JSON.stringify(requestOri.where));
    } else {
      where = {
        and: [
          {
            active: true
          }
        ]
      };
    }
    if (requestOri && requestOri.relation && requestOri.relation.order) {
      order = ',"order":"' + JSON.parse(JSON.stringify(requestOri.relation.order)) + '"';
    } else {
      order = '';
    }
    if (filter != null && filter.length > 0) {
      if (page > 0 && perPage > 0) {
        filterO = '"limit":' + perPage;
      }
    } else {
      if (perPage != 0) {
        filterO = '"limit":' + perPage;
      }
    }
    if (skip > 0) {
      filterO = '"skip":' + skip;
    }
    if (filter) {
      for (let i = 0; i <= filter.length - 1; i++) {
        if (!filter[i]['or']) {
          const fieldName: string = filter[i].fieldName;
          let operator: string = filter[i].operator;
          const include: string = filter[i].include;
          const filterO: any = {};
          if (!operator) operator = '=';
          if (operator == '=') {
            filterO[fieldName] = filter[i].value;
          } else {
            const operatorO: any = {};
            operatorO[operator] = filter[i].value;
            filterO[fieldName] = operatorO;
          }
          if (include) {
            if (request && request['relation'] && request['relation']['include']) {
              for (let j = 0; j <= request['relation']['include'].length - 1; j++) {
                if (request['relation']['include'][j].relation == include) {
                  if (!request['relation']['include'][j].scope) {
                    request['relation']['include'][j]['scope'] = {};
                  }
                  if (!request['relation']['include'][j].scope.where) {
                    request['relation']['include'][j].scope['where'] = {};
                  }
                  if (!request['relation']['include'][j].scope.where.and) {
                    request['relation']['include'][j].scope.where['and'] = [];
                  }
                  request['relation']['include'][j].scope.where['and'].push(filterO);
                } else {
                  if (request['relation']['include'][j].scope) {
                    for (let k = 0; k <= request['relation']['include'][j].scope.include.length - 1; k++) {
                      if (!request['relation']['include'][j].scope.include[k].scope) {
                        request['relation']['include'][j].scope.include[k]['scope'] = {};
                      }
                      if (!request['relation']['include'][j].scope.include[k].scope.where) {
                        request['relation']['include'][j].scope.include[k].scope['where'] = {};
                      }
                      if (!request['relation']['include'][j].scope.include[k].scope.where.and) {
                        request['relation']['include'][j].scope.include[k].scope.where['and'] = [];
                      }
                      request['relation']['include'][j].scope.include[k].scope.where['and'].push(filterO);
                    }
                  }
                }
              }
            }
          } else {
            where['and'].push(filterO);
          }
        } else {
          where['and'].push(filter[i]);
        }
      }
    }
    if (globalFilter) {
      const globalWhere: any = {};
      globalWhere['or'] = [];
      const expression: any = {};
      expression['regexp'] = '/' + globalFilter + '/i';
      for (let i = 0; i <= request.columns.length - 1; i++) {
        if (request.columns[i].datatype == 0 && request.columns[i].visible) {
          const filterO: any = {};
          filterO[request.columns[i].fieldName] = expression;
          if (request.columns[i].includes) {
            if (request && request['relation'] && request['relation']['include']) {
              for (let j = 0; j <= request['relation']['include'].length - 1; j++) {
                if ((request.columns[i].includes) && (request['relation']['include'][j].relation == request.columns[i].includes[request.columns[i].includes.length - 1])) {
                  if (!request['relation']['include'][j].scope) {
                    request['relation']['include'][j]['scope'] = {};
                  }
                  if (!request['relation']['include'][j].scope.where) {
                    request['relation']['include'][j].scope['where'] = {};
                  }
                  if (!request['relation']['include'][j].scope.where.or) {
                    request['relation']['include'][j].scope.where['or'] = [];
                  }
                  request['relation']['include'][j].scope.where['or'].push(filterO);
                  break;
                }
              }
            }
          } else {
            globalWhere['or'].push(filterO);
          }
        }
      }
      if (globalWhere['or']) {
        where['and'].push(globalWhere);
      }
    }
    if (where) {
      where = JSON.stringify(where);
    }
    if (request && request['relation'] && request['relation']['include']) {
      if (filterO) {
        url = url + this.getSymbol(url) + 'filter=' + '{' + filterO + ',"include": ' + JSON.stringify(request['relation']['include']) + ',"where": ' + where + order + '}';
      } else {
        url = url + this.getSymbol(url) + 'filter=' + '{"include": ' + JSON.stringify(request['relation']['include']) + ',"where": ' + where + order + '}';
      }
    } else {
      if (filterO) {
        url = url + this.getSymbol(url) + 'filter=' + '{' + filterO + ',"where":' + where + '}';
      } else {
        url = url + this.getSymbol(url) + 'filter={"where":' + where + '}';
      }
    }
    url = GenericdatasetSettings.api_endpoint + this.restName + url;
    return this.http.get(url, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getItem(id: number, filter?: string[]): Observable<any> {
    let restName = this.restName;
    /*let model: any = null;
    try {
      import('../../models/' + this.modelName.toLowerCase()).then((a) => {
        model = a[this.modelName];
        model = new model();
      });
    } catch (error) {
      import('../../models/default').then((a) => {
        model = a['Default'];
        model = new model();
      });
    }*/
    if (id > 0) {
      let include: string = '';
      if (filter) {
        for (let i = 0; i <= filter.length - 1; i++) {
          if (i == 0) {
            include = '?filter={"include": [';
          }
          include = include + '"' + filter[i] + '"';
          if (i != filter.length - 1) {
            include = include + ",";
          }
          if (i == filter.length - 1) {
            include = include + "]}";
          }

        }
      }
      let url: string = GenericdatasetSettings.api_endpoint + restName + '/' + id;
      if (include) url = url + include;
      return this.http.get(url, this.options)
        .map((res: Response) => {
          const body = res.json();
          /*for (let property in model) {
            if (typeof model[property] !== 'function') body[property] = model[property];
          }*/
          return body;
        })
        .catch(this.handleError)
    } else {
      return Observable.of(new Object());
    } /*else {
      try {
        let model = require('../../models/' + this.modelName.toLowerCase() + '.ts')[this.modelName];
        return Observable.of(new model());
      } catch (error) {
        let model = require('../../models/default.ts')['Default'];
        return Observable.of(new model());
      }
    }*/
  }
  getUrl(param: any): Observable<any> {
    return this.http.get(GenericdatasetSettings.api_endpoint + param, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  getExternalUrl(param: any): Observable<any> {
    return this.http.get(param, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  getItemFromLink(item: any): Observable<any> {
    return this.http.get(item.link.href, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  public extractData(res: Response) {
    const body = res.json();
    return body;
  }
  public handleError(error: any) {
    let body: any;
    if (error instanceof Response) {
      body = (error as any)._body;
      if (error.ok == false) {
        body = {};
        body['code'] = '500';
        body['errorList'] = [];
        body['errorList'].push({ code: 1000, columnName: '', description: 'No backend found', url: 'http://www.sitarm.com/error/1000' });
      }
    } else {
      body = body.error || JSON.stringify(body);
    }
    return Observable.throw(body);
  }
  addItem(name: string): Observable<any> {
    const body = JSON.stringify({ name });
    const options = new RequestOptions({ headers: this.headers });
    return this.http.post(GenericdatasetSettings.api_endpoint + this.restName + '/', body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  insertItem(body: any): Observable<any> {
    const bodyString = JSON.stringify(body);
    const options = new RequestOptions({ headers: this.headers });
    if (body) delete body['id'];
    return this.http.post(GenericdatasetSettings.api_endpoint + this.restName + '/', body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  deleteItem(item: any, id: number): Observable<any[]> {
    if (!item) item = {};
    item.active = false;
    return this.http.patch(GenericdatasetSettings.api_endpoint + this.restName + '/' + id, item, this.options)
      .map(() => null)
      .catch(this.handleError);
  }
  saveItem(body: any, id: number): Observable<any[]> {
    if (id > 0) {
      return this.updateItem(body, id);
    } else {
      return this.insertItem(body);
    }
  }
  updateItem(body: any, id: number): Observable<any[]> {
    return this.http.patch(GenericdatasetSettings.api_endpoint + this.restName + '/' + id, body, this.options)
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }
}